/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Management Operations siehe: https://simstation.atlassian.net/wiki/spaces/SOF/pages/397836289/JUMP+BYU+Implementation
 */ 
export enum Permissions {
    /**
     * Used for removed ACLs
     */ 
    Unknown = -100,
    Everyone = -99,
    Create_Exam_Session = 1,
    Create_Pro_Session = 2,
    Debriefing_Access = 3,
    LiveView_Access = 7,
    CanJoinAnyTrainingSession = 99,
    CanJoinTrainingAsViewingStation = 102,
    CanStartAnyVisibleSession = 103,
    ScenarioRecording_Access = 1000,
    ScenarioRecording_ViewAll = 1001,
    ScenarioRecording_EditAll = 1002,
    ScenarioRecording_ExportAll = 1003,
    ScenarioRecording_DeleteAll = 1004,
    ScenarioRecording_DeleteFromTablet = 1005,
    ScenarioRecording_TrackingViewAll = 1006,
    ScenarioRecording_ChecklistsViewAll = 1007,
    ScenarioRecording_InstructorViewAll = 1008,
    ScenarioRecording_LearnerViewAll = 1009,
    ScenarioRecording_StandardizedPatientViewAll = 1010,
    ScenarioRecording_BookmarkViewAll = 1011,
    ScenarioRecording_EditAllParticipants = 1012,
    ScenarioRecording_ConvertToFileSet = 1050,
    ScenarioRecording_ViewFileSets = 1051,
    Scenario_Access = 1200,
    Scenario_ViewAll = 1201,
    Scenario_Create = 1202,
    Scenario_Import = 1203,
    Scenario_EditAll = 1204,
    Scenario_DuplicateAll = 1205,
    Scenario_ExportAll = 1206,
    Scenario_DeleteAll = 1207,
    ScenarioGroup_Access = 1250,
    Lib_BookmarkSets_Access = 1300,
    Lib_BookmarkSet_ViewAll = 1301,
    Lib_BookmarkSets_Create = 1302,
    Lib_BookmarkSets_Import = 1303,
    Lib_BookmarkSets_EditAll = 1304,
    Lib_BookmarkSets_DuplicateAll = 1305,
    Lib_BookmarkSets_ExportAll = 1306,
    Lib_BookmarkSets_DeleteAll = 1307,
    Lib_Sounds_Access = 1400,
    Lib_Sounds_ViewAll = 1401,
    Lib_Sounds_Create = 1402,
    Lib_Sounds_Import = 1403,
    Lib_Sounds_EditAll = 1404,
    Lib_Sounds_DuplicateAll = 1405,
    Lib_Sounds_ExportAll = 1406,
    Lib_Sounds_DeleteAll = 1407,
    Lib_Medias_Access = 1500,
    Lib_Medias_ViewAll = 1501,
    Lib_Medias_Create = 1502,
    Lib_Medias_Import = 1503,
    Lib_Medias_EditAll = 1504,
    Lib_Medias_DuplicateAll = 1505,
    Lib_Medias_ExportAll = 1506,
    Lib_Medias_DeleteAll = 1507,
    Lib_Checklists_Access = 1600,
    Lib_Checklists_ViewAll = 1601,
    Lib_Checklists_Create = 1602,
    Lib_Checklists_Import = 1603,
    Lib_Checklists_EditAll = 1604,
    Lib_Checklists_DuplicateAll = 1605,
    Lib_Checklists_ExportAll = 1606,
    Lib_Checklists_DeleteAll = 1607,
    Assessments_Template_Access = 1650,
    Assessments_Conducted_Access = 1651,
    Assessments_Conducted_AccessAll = 1652,
    Assessments_Conducted_DeleteAll = 1654,
    Assessments_Template_ViewAll = 1655,
    Assessments_Template_Create = 1656,
    Assessments_Template_EditAll = 1657,
    Assessments_Template_DeleteAll = 1653,
    MasterofCeremony_App_Access = 1660,
    Confirmation_App_Access = 1661,
    Assessments_Settings_Access = 1680,
    Device_Configuration_Access = 1681,
    ExamFlow_Access = 1690,
    ExamRemoteExamination = 1691,
    ExamDetails_ViewAll = 1692,
    Exam_Organizer = 1693,
    Exam_Schedule = 1694,
    Lib_VoG_Access = 1700,
    Lib_VoG_ViewAll = 1701,
    Lib_VoG_Create = 1702,
    Lib_VoG_Import = 1703,
    Lib_VoG_EditAll = 1704,
    Lib_VoG_DuplicateAll = 1705,
    Lib_VoG_ExportAll = 1706,
    Lib_VoG_DeleteAll = 1707,
    Lib_VoP_Access = 1800,
    Lib_VoP_ViewAll = 1801,
    Lib_VoP_Create = 1802,
    Lib_VoP_Import = 1803,
    Lib_VoP_EditAll = 1804,
    Lib_VoP_DuplicateAll = 1805,
    Lib_VoP_ExportAll = 1806,
    Lib_VoP_DeleteAll = 1807,
    MultiScene_Access = 1900,
    MultiScene_ViewAll = 1901,
    MultiScene_Create = 1902,
    MultiScene_Import = 1903,
    MultiScene_EditAll = 1904,
    MultiScene_DuplicateAll = 1905,
    MultiScene_ExportAll = 1906,
    MultiScene_DeleteAll = 1907,
    EventPlanner_Access = 2000,
    EventPlanner_ViewAll = 2001,
    EventPlanner_Create = 2002,
    EventPlanner_Import = 2003,
    EventPlanner_EditAll = 2004,
    EventPlanner_DuplicateAll = 2005,
    EventPlanner_ExportAll = 2006,
    EventPlanner_DeleteAll = 2007,
    Notification_Access = 2200,
    Notification_ViewAll = 2201,
    Notification_DeleteAll = 2202,
    Translations_Access = 2300,
    Translations_ViewAll = 2301,
    Translations_Manage = 2302,
    UserManagement_Access = 2400,
    UserManagement_ViewAll = 2401,
    UserManagement_Create = 2402,
    UserManagement_EditAll = 2403,
    UserManagement_DeleteAll = 2404,
    UserManagement_IDCard = 2405,
    UserManagement_SetRoles = 2406,
    UserManagement_UploadExcel = 2407,
    UserManagement_ImportFromInitializationData = 2408,
    UserManagement_ReloadClients = 2409,
    UserManagement_PermissionToChangeAllPasswords = 2410,
    UserManagement_PermissionToChangeOwnPassword = 2411,
    Acl_Access = 2500,
    DataAcl_Access = 2501,
    UserSettings = 2502,
    SyncRecording_Access = 2600,
    Configuration_Access = 3000,
    Configuration_ViewCameras = 3001,
    Configuration_ViewTrainingRooms = 3002,
    Configuration_ViewAudioInputChannels = 3004,
    Configuration_ViewPhoneAudioInputChannels = 3005,
    Configuration_ViewAudioOutputChannels = 3006,
    Configuration_ViewAudioChannelGroups = 3007,
    Configuration_ViewRecorderMappings = 3010,
    Configuration_ViewPlayerMappings = 3011,
    Configuration_ViewTabletMappings = 3012,
    Configuration_ViewViewingStationMappings = 3013,
    Configuration_ViewTrainingRoomPcMappings = 3014,
    Configuration_ViewTrainingRoomGroups = 3015,
    Configuration_ViewRecordingServerConfiguration = 3020,
    Configuration_ViewSettings = 3021,
    Configuration_ViewLdapRoleMappings = 3023,
    Configuration_LdapSettings = 3024,
    Configuration_ViewLicense = 3025,
    Configuration_ViewExstreamers = 3026,
    Configuration_ViewIpDevices = 3027,
    Configuration_NetworkAudioInputChannels = 3028,
    Configuration_OutlookConfig = 3029,
    Scheduler_Access = 3100,
    Scheduler_Schedulers = 3101,
    Scheduler_Download = 3102,
    Scheduler_Export = 3103,
    Scheduler_AdaptVideoLength = 3104,
    Scheduler_DeleteTemporaryFiles = 3105,
    Scheduler_Synchronization = 3106,
    Scheduler_SwitchcastUpload = 3107,
    Scheduler_SwitchcastProcessing = 3108,
    RecorderStatus_Access = 4100,
    CacheManager_Access = 4125,
    AuditTrail_Access = 4150,
    WebPageManagement_Access = 4200,
    DigitalSignage_Access = 4300,
    DigitalSignageRoom_EditAllRoomNames = 4321,
    DigitalSignageRoom_EditAllCamSources = 4322,
    DigitalSignageRoom_EditAllCamHomePositions = 4323,
    DigitalSignageRoom_Add = 4324,
    DigitalSignageRoom_DeleteAll = 4325,
    DigitalSignageRoom_MoveAll = 4326,
    Tracker_Access = 4400,
    WebClientConnectionHistory_Access = 4500,
    StageDesigner_Access = 6000,
    EnableChangingCamPosition = 6001,
    EnableChangingCamPositionDirectlyInSingleRecording = 6010,
    EnableSetRestorePoint = 6015,
    EnableResetToRestorePoint = 6016,
    RoomPlanner_Access = 7000,
    TrainingRoom_EditAllRoomNames = 6020,
    TrainingRoom_EditAllCamSources = 6021,
    TrainingRoom_EditAllCamHomePositions = 6022,
    EnergySaving_Access = 8000,
    EnergySaving_PDU_Access = 8010,
    EnergySaving_Player_Access = 8020,
    EnergySaving_Recorder_Access = 8030,
    EnergySaving_Tablet_Access = 8040,
    EnergySaving_TrainingRoomEntrance_Access = 8050,
    EnergySaving_ViewingStation_Access = 8060,
    EnergySaving_PowerOnAll = 8070,
    EnergySaving_PowerOffAll = 8080,
    EnergySaving_EditMasterPassword = 8090,
    EnergySchedule_Access = 8500,
    EnergySchedule_Edit_Access = 8510,
    WifiManagement_Access = 9000,
    Management_Apps_Access = 10000,
    Lib_Access = 10001,
    Support_Access = 11000,
    CameraView_Access = 12000,
    HealthMonitor_Access = 13000,
    Presentation_Access = 14000,
    ExportOverview_Access = 15000,
    ControlPanels_Access = 16000,
    Dashboard_Access = 17000,
    TrainTheTrainer_Access = 18000,
    RoleManagment_Access = 19000,
    AutoUpdate_Access = 20000,
    Reports_Access = 20100,
    Grafana_Reports_Access = 20101,
    RegisterDevice = 21000,
    GroupManager_Access = 22000,
}
